export default "__VITE_ASSET__DueMxja1__"